import React, { useEffect, useRef } from "react";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "@components/index";
import { StoreProvider, createRootStore } from "@stores/index";
import type { RootStore } from "@stores/index";
import Router from "@/Router";
import { AppLogger } from "@utils/index";

function App(): React.JSX.Element {
    const rootStoreRef = useRef<RootStore | null>(null);

    if (rootStoreRef.current === null) {
        rootStoreRef.current = createRootStore();
    }

    const rootStore = rootStoreRef.current;

    useEffect(() => {
        rootStore.initialize().catch((error: unknown) => {
            AppLogger.error("Failed to initialize app:", error);
        });

        return () => {
            rootStore.dispose();
        };
    }, [rootStore]);

    return (
        <ErrorBoundary>
            <StoreProvider store={rootStore}>
                <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                    <Router />
                </BrowserRouter>
            </StoreProvider>
        </ErrorBoundary>
    );
}

export default App;
